:host(.ion-color) {
  color: var(--ion-color-base);
}